export const GET_NETOPIA_SIGN = 'GET_NETOPIA_SIGN';
